<span class="attribution-text">{{ 'woa.label.common.poweredBy' | translate }}</span>
<woa-chewzie-logo></woa-chewzie-logo>
